// ========================================
// ================== V3 ==================
// ========================================

import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";

const initialState = {
  code: null,
  code_error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.V3_CODE_SET:
      return fetchCodeSet(state, action);
    case aTypes.V3_CODE_FETCH_FAIL:
      return fetchCodeSetFail(state, action);
    default:
      return state;
  }
};

const fetchCodeSet = (state, action) => {
  return updateObject(state, {
    code: action.code,
  });
};

const fetchCodeSetFail = (state, action) => {
  return updateObject(state, {
    code_error: action.error,
  });
};

export default reducer;
